import { TOSS_PAYMENT_CONFIRM } from '@/store/types'
import axios from '@/store/axios'
const state = {}

const getters = {}

const actions = {
  [TOSS_PAYMENT_CONFIRM]: (commit, { requestData, orderData }) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/payment/confirm', {
          requestData: requestData,
          orderData: orderData
        })
        .then(resolve)
        .catch(reject)
    })
  }
}
const mutations = {}
export default {
  state,
  getters,
  actions,
  mutations
}
